/** Dopuszczalne stany odpowiedzi na żądanie */
export var ResponseState;
(function (ResponseState) {
    ResponseState["Rejected"] = "rejected";
    ResponseState["CommunicationFailure"] = "communication-failure";
    ResponseState["Success"] = "success";
})(ResponseState || (ResponseState = {}));
